import filters from './filters/actions'
import table from './table/actions'
import tableViolations from './tableViolations/actions'
import tableDeviations from './tableDeviations/actions'


export default {
  filters,
  table,
  tableViolations,
  tableDeviations,
}
